const n = (e) => {
  const a = e.name.replace(/([^a-zA-Z0-9-_. ])/g, "_");
  return new File([e], a, { type: e.type });
};
export {
  n as massageFilename
};
